export default "__VITE_ASSET__Dzo5EUZY__"